import { Modal, Layout, Image, Row, Col, Button, message, Typography, Card, ConfigProvider, Checkbox, Popconfirm } from 'antd';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom'
import { ArrowRightOutlined, PlusOutlined, EditOutlined } from '@ant-design/icons';
import WYSIWYGModal from './components/WYSIWYGModal';
import './css/cramSchool.css';
import Label_language from '../language';
import { useContext } from 'react';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import LogoList from './LogoList';
import BlogCard from './components/BlogCard';
const { Paragraph, Text } = Typography;
const label_language = Label_language.cramschool.children
const Home = () => {
    const language = useContext(ConfigProvider.ConfigContext).locale.locale
    const defaultList = [{ title: label_language.home.children.lesson_category[language], show: 'yes' }, { title: label_language.home.children.news[language], show: 'yes' }, { title: label_language.home.children.tidbits[language], show: 'yes' }, { title: label_language.home.children.environment[language], show: 'yes' }, { title: label_language.home.children.teachers[language], show: 'yes' }];
    const [itemList, setItemList] = useState(defaultList);
    const navigate = useNavigate();
    const [background_color, set_background_color] = useState([]);
    const [open, setOpen] = useState(false);
    const [open_wyswyg, set_open_wyswyg] = useState(false);
    const [content, setContent] = useState('');
    const [news_data, set_news_data] = useState([]);
    const [class_data, set_class_data] = useState([]);
    const [environment_data, set_environment_data] = useState([]);
    const [teacher_data, set_teacher_data] = useState([]);
    const [block_modal, set_block_modal] = useState(false);
    const [classintroduce_data, set_classintroduce_data] = useState([]);
    const [messageApi, contextHolder] = message.useMessage();
    const [permission, setPermission] = useState(false);
    const [dimensions, setDimensions] = useState({
        height: window.innerHeight,
        width: window.innerWidth
    });

    const get_news_data = () => {
        axios
            .get('/cramSchool/api/blog/lastest', { params: { "blog_type_id": 1 } })
            .then((response) => {
                let data_tmp = response.data.data.slice(0, 4)
                set_news_data(data_tmp);
                get_picture(data_tmp);
            })
    }
    const get_class_data = () => {
        axios
            .get('/cramSchool/api/blog/tidbits', { params: { "blog_type_id": 3 } })
            .then((response) => {
                let data_tmp = response.data.data.slice(0, 4)
                set_class_data(data_tmp);
                get_class_picture(data_tmp);
            })
    }
    const get_classintroduce_data = () => {
        axios
            .get('/cramSchool/api/blog/lesson_category', { params: { "blog_type_id": 5 } })
            .then((response) => {
                let data_tmp = response.data.data.slice(0, 4)
                set_classintroduce_data(data_tmp);
                get_classintroduce_picture(data_tmp);
            })
    }
    const get_header = () => {
        axios
            .get('/cramSchool/api/blog/header/lastest', { params: { "blog_type_id": 9 } })
            .then((response) => {
                setContent(response.data.data[0]);
            })
    }
    const get_block = () => {
        axios
            .get('/cramSchool/api/custom_page_setting', {
                params: {
                    page_name: 'home',
                }
            })
            .then((response => {
                setItemList(response.data[0].custom_setting);
            }))
    }
    const get_environment_data = () => {
        axios
            .get('/cramSchool/api/blog/surrounding', { params: { "blog_type_id": 2 } })
            .then((response) => {
                let data_tmp = response.data.data.slice(0, 4)
                set_environment_data(data_tmp);
                get_environment_picture(data_tmp);
            })
    }
    const get_teacher_data = () => {
        axios
            .get('/cramSchool/api/blog/teacher', { params: { "blog_type_id": 4 } })
            .then((response) => {
                let data_tmp = response.data.data.slice(0, 3)
                set_teacher_data(data_tmp);
                get_teacher_picture(data_tmp);
            })
    }
    const get_color = () => {
        axios
            .get('/cramSchool/api/blog/type_list')
            .then((response) => {
                response.data.data.map((item, i) => {
                    let item_color = item.background_color.split(',');
                    // console.log(item_color);
                    set_background_color((pre) => {
                        return ({
                            ...pre,
                            [`${item.name}1`]: item_color[0],
                            [`${item.name}2`]: item_color[1]
                        })
                    })
                })
            })
    }
    useEffect(() => {
        console.log(background_color)
    }, [background_color])
    useEffect(() => {
        get_color();
        get_news_data();
        get_class_data();
        get_classintroduce_data();
        get_environment_data();
        get_teacher_data();
        get_header();
        get_block();
        axios
            .get('/cramSchool/api/permission')
            .then((response) => {
                if (response.data.length != 0) {
                    setPermission(true);
                }
            })
    }, [])
    useEffect(() => {
        const debouncedHandleResize = function handleResize() {
            setDimensions({
                height: window.innerHeight,
                width: window.innerWidth
            });
        };

        window.addEventListener("resize", debouncedHandleResize);

        return _ => {
            window.removeEventListener("resize", debouncedHandleResize);
        };
    }, [])
    const get_picture = (data_tmp) => {
        // console.log(data_tmp);
        data_tmp && data_tmp.map((value, index) => {
            let blog_id = value['blog_id']
            if (value.file_id.length != 0) {
                value.file_id.map((tmp, key) => {
                    // console.log(key, tmp);
                    // tmp['file_id']
                    axios
                        .get('/cramSchool/api/file', { responseType: 'blob', params: { "file_id": tmp } })
                        .then((response) => {
                            var blob_ = new Blob([response.data], {
                                type: "image/jpg",// this is the only MIME for SVG

                            });
                            const dataurl = URL.createObjectURL(blob_);
                            set_news_data(
                                (pre) => {
                                    return (
                                        pre.map((value, index) => {
                                            if (blog_id == value.blog_id) {
                                                if (value.file_url != undefined) {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [...value.file_url, dataurl]
                                                        }
                                                    )
                                                } else {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [dataurl]
                                                        }
                                                    )
                                                }
                                            } else {
                                                return (
                                                    { ...value }
                                                )

                                            }
                                        })
                                    )
                                }
                            )

                        })
                })
            }
        })

    }
    const get_class_picture = (data_tmp) => {
        // console.log(data_tmp);
        data_tmp && data_tmp.map((value, index) => {
            let blog_id = value['blog_id']
            if (value.file_id.length != 0) {
                value.file_id.map((tmp, key) => {
                    // console.log(key, tmp);
                    // tmp['file_id']
                    axios
                        .get('/cramSchool/api/file', { responseType: 'blob', params: { "file_id": tmp } })
                        .then((response) => {
                            var blob_ = new Blob([response.data], {
                                type: "image/jpg",// this is the only MIME for SVG

                            });
                            const dataurl = URL.createObjectURL(blob_);
                            set_class_data(
                                (pre) => {
                                    return (
                                        pre.map((value, index) => {
                                            if (blog_id == value.blog_id) {
                                                if (value.file_url != undefined) {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [...value.file_url, dataurl]
                                                        }
                                                    )
                                                } else {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [dataurl]
                                                        }
                                                    )
                                                }
                                            } else {
                                                return (
                                                    { ...value }
                                                )

                                            }
                                        })
                                    )
                                }
                            )

                        })
                })
            }
        })
    }
    const get_classintroduce_picture = (data_tmp) => {
        // console.log(data_tmp);
        data_tmp && data_tmp.map((value, index) => {
            let blog_id = value['blog_id']
            if (value.file_id.length != 0) {
                value.file_id.map((tmp, key) => {
                    // console.log(key, tmp);
                    // tmp['file_id']
                    axios
                        .get('/cramSchool/api/file', { responseType: 'blob', params: { "file_id": tmp } })
                        .then((response) => {
                            var blob_ = new Blob([response.data], {
                                type: "image/jpg",// this is the only MIME for SVG

                            });
                            const dataurl = URL.createObjectURL(blob_);
                            set_classintroduce_data(
                                (pre) => {
                                    return (
                                        pre.map((value, index) => {
                                            if (blog_id == value.blog_id) {
                                                if (value.file_url != undefined) {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [...value.file_url, dataurl]
                                                        }
                                                    )
                                                } else {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [dataurl]
                                                        }
                                                    )
                                                }
                                            } else {
                                                return (
                                                    { ...value }
                                                )

                                            }
                                        })
                                    )
                                }
                            )

                        })
                })
            }
        })
    }
    const get_environment_picture = (data_tmp) => {
        data_tmp && data_tmp.map((value, index) => {
            let blog_id = value['blog_id']
            if (value.file_id.length != 0) {
                value.file_id.map((tmp, key) => {
                    // console.log(key, tmp);
                    // tmp['file_id']
                    axios
                        .get('/cramSchool/api/file', { responseType: 'blob', params: { "file_id": tmp } })
                        .then((response) => {
                            var blob_ = new Blob([response.data], {
                                type: "image/jpg",// this is the only MIME for SVG

                            });
                            const dataurl = URL.createObjectURL(blob_);
                            set_environment_data(
                                (pre) => {
                                    return (
                                        pre.map((value, index) => {
                                            if (blog_id == value.blog_id) {
                                                if (value.file_url != undefined) {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [...value.file_url, dataurl]
                                                        }
                                                    )
                                                } else {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [dataurl]
                                                        }
                                                    )
                                                }
                                            } else {
                                                return (
                                                    { ...value }
                                                )

                                            }
                                        })
                                    )
                                }
                            )

                        })
                })
            }
        })
    }
    const get_teacher_picture = (data_tmp) => {
        data_tmp && data_tmp.map((value, index) => {
            let blog_id = value['blog_id']
            if (value.file_id.length != 0) {
                value.file_id.map((tmp, key) => {
                    // console.log(key, tmp);
                    // tmp['file_id']
                    axios
                        .get('/cramSchool/api/file', { responseType: 'blob', params: { "file_id": tmp } })
                        .then((response) => {
                            var blob_ = new Blob([response.data], {
                                type: "image/jpg",// this is the only MIME for SVG

                            });
                            const dataurl = URL.createObjectURL(blob_);
                            set_teacher_data(
                                (pre) => {
                                    return (
                                        pre.map((value, index) => {
                                            if (blog_id == value.blog_id) {
                                                if (value.file_url != undefined) {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [...value.file_url, dataurl]
                                                        }
                                                    )
                                                } else {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [dataurl]
                                                        }
                                                    )
                                                }
                                            } else {
                                                return (
                                                    { ...value }
                                                )

                                            }
                                        })
                                    )
                                }
                            )

                        })
                })
            }
        })

    }
    const handleUpdate = () => {
        var Today = new Date();
        let time = `${Today.getFullYear()}-${Today.getMonth() + 1}-${Today.getDate()}`;
        axios
            .patch(`/cramSchool/api/blog/header/lastest`, [{
                // "title": 'lastest_header',
                // "content": content,
                ...content,
                "blog_type_id": 9,
                "annoucement_time": time,
                // "blog_id": 103

            }])
            .then((response) => {
                if (response.data.status == 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: label_language.Common.children.edit_error[language],
                    });
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: label_language.Common.children.edit_success[language],
                    });
                }
                get_header();
                set_open_wyswyg(false);
            })
    }
    const course = () => {
        return (
            <>
                { /* 課程 */}
                <Col span={24}>
                    <Row justify={'center'} align="middle" style={{ backgroundImage: `linear-gradient(to right, ${background_color?.lesson1}, rgb(255, 255, 255), ${background_color?.lesson2}`, padding: '10px', position: 'relative' }}>
                        <Col style={{ textAlign: 'center' }}>
                            <span style={{ fontSize: dimensions['width'] > 500 ? '3.5rem' : '3rem' }}>{label_language.home.children.lesson_category[language]}</span>
                        </Col>
                        {/* <Col style={{ position: 'absolute', left: '90%', top: '0%' }}>
                            <Button className='example' size='large' shape="circle" icon={<EditOutlined />} style={{ position: 'absolute', top: 0, right: 0, backgroundColor: '#F9D4E5' }} onClick={e => set_open_wyswyg(true)} />
                        </Col> */}
                    </Row>
                </Col>
                <Col span={24}>
                    <Row justify={'center'} gutter={[40, 8]}>
                        <BlogCard title={true} edit={false} span={6} data={classintroduce_data} type={'straight'} page={'ClassIntroduce'} />
                    </Row>
                </Col>
                <Col span={24}>
                    <Row justify='end' style={{ padding: '10px' }}>
                        <Col style={{ cursor: 'pointer' }} onClick={(e) => navigate('/cramSchool/ClassIntroduce')}>
                            <div className='example'>{label_language.home.children.show_more[language] && '查看更多'}<ArrowRightOutlined /></div>
                        </Col>
                    </Row>
                </Col>
            </>
        )
    }
    const news = () => {
        return (
            <>
                {/* 最新消息 */}
                <Col span={24}>
                    <Row justify={'center'} align="middle" style={{ backgroundImage: `linear-gradient(to right,${background_color?.header_lastest1}, #ffffff,${background_color?.header_lastest2})`, padding: '10px', position: 'relative' }}>
                        <Col>
                            <Col style={{ textAlign: 'center' }}>
                                <span style={{ fontSize: '3.5rem' }}>{label_language.home.children.news[language]}</span>
                            </Col>
                        </Col >
                    </Row>
                </Col>
                <Col span={24}>
                    <Row gutter={[40, 8]} justify='center'>
                        <BlogCard title={true} edit={false} span={6} data={news_data} type={'straight'} page={'News'} />
                    </Row>
                </Col>
                <Col span={24}>
                    <Row justify='end' style={{ padding: '10px' }}>
                        <Col style={{ cursor: 'pointer' }} onClick={(e) => navigate('/cramSchool/News')}>
                            <div className='example'>{label_language.home.children.show_more[language] && '查看更多'}<ArrowRightOutlined /></div>
                        </Col>
                    </Row>
                </Col>
            </>
        )
    }
    const tidbits = () => {
        return (
            <>
                {/* 上課花絮 */}
                <Col span={24}>
                    <Row justify={'center'} align="middle" style={{ backgroundImage: `linear-gradient(to right, ${background_color?.header_tidbits1}, #ffffff, ${background_color?.header_tidbits2}`, padding: '10px', position: 'relative' }}>
                        <Col>
                            <Col style={{ textAlign: 'center' }}>
                                <span style={{ fontSize: '3.5rem' }}>{label_language.home.children.tidbits[language]}</span>
                            </Col>
                        </Col >
                    </Row>
                </Col>
                <Col span={24}>
                    <Row justify={'center'} gutter={[40, 16]}>
                        <BlogCard title={true} edit={false} span={6} data={class_data} type={'horizontal'} page={'Class'} />
                    </Row>
                </Col>
                <Col span={24}>
                    <Row justify='end' style={{ padding: '10px' }}>
                        <Col style={{ cursor: 'pointer' }} onClick={(e) => navigate('/cramSchool/Class')}>
                            <div className='example'>{label_language.home.children.show_more[language] && '查看更多'}<ArrowRightOutlined /></div>
                        </Col>
                    </Row>
                </Col>
            </>
        )
    }
    const environment = () => {
        return (
            <>
                {/* 環境介紹 */}
                <Col span={24}>
                    <Row justify={'center'} align="middle" style={{ backgroundImage: `linear-gradient(to right, ${background_color?.header_environment1}, #ffffff, ${background_color?.header_environment2}`, padding: '10px', position: 'relative' }}>
                        <Col>
                            <Col style={{ textAlign: 'center' }}>
                                <span style={{ fontSize: '3.5rem' }}>{label_language.home.children.environment[language]}</span>
                            </Col>
                        </Col >
                    </Row>
                </Col>
                <Col span={24}>
                    <Row justify={'center'} gutter={[40, 16]}>
                        <BlogCard title={true} edit={false} span={6} data={environment_data} type={'horizontal'} page={'Environment'} />
                    </Row>
                </Col>
                <Col span={24}>
                    <Row justify='end' style={{ padding: '10px' }}>
                        <Col style={{ cursor: 'pointer' }} onClick={(e) => navigate('/cramSchool/Environment')}>
                            <div className='example'>{label_language.home.children.show_more[language] && '查看更多'}<ArrowRightOutlined /></div>
                        </Col>
                    </Row>
                </Col>
            </>
        )
    }
    const teacher = () => {
        return (
            <>
                {/* 師資介紹 */}
                <Col span={24}>
                    <Row justify={'center'} align="middle" style={{ backgroundImage: `linear-gradient(to right, ${background_color?.header_teacher_blog1}, #ffffff, ${background_color?.header_teacher_blog2})`, padding: '10px', position: 'relative' }}>
                        <Col>
                            <Col style={{ textAlign: 'center' }}>
                                <span style={{ fontSize: '3.5rem' }}>{label_language.home.children.teachers[language]}</span>
                            </Col>
                        </Col >
                    </Row>
                </Col>
                <Col span={24}>
                    <Row justify={'center'} gutter={[40, 8]}>
                        <BlogCard title={true} edit={false} span={8} data={teacher_data} type={'straight'} page={'Teachers'} />
                    </Row>
                </Col>
                <Col span={24}>
                    <Row justify='end' style={{ padding: '10px' }}>
                        <Col style={{ cursor: 'pointer' }} onClick={(e) => navigate('/cramSchool/Teachers')}>
                            <div className='example'>{label_language.home.children.show_more[language] && '查看更多'}<ArrowRightOutlined /></div>
                        </Col>
                    </Row>
                </Col>
            </>
        )
    }
    const handleDrop = (droppedItem) => {
        // Ignore drop outside droppable container
        if (!droppedItem.destination) return;
        var updatedList = [...itemList];
        // Remove dragged item
        const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1);
        // Add dropped item
        updatedList.splice(droppedItem.destination.index, 0, reorderedItem);
        // Update State
        // console.log(updatedList);
        setItemList(updatedList);
    };
    const updateBlock = () => {
        axios
            .post('/cramSchool/api/custom_page_setting', [{
                page_name: 'home',
                custom_setting: itemList
            }])
            .then((response) => {
                if (response.data.status == 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: label_language.Common.children.edit_error[language],
                    });
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: label_language.Common.children.edit_success[language],
                    });
                }
            })
        set_block_modal(false);
    }
    const handleOnChange = (item, e) => {
        // console.log(item, e.target.checked);
        setItemList(prev => {
            return (
                prev.map((value, i) => {
                    if (value.title == item) {
                        if (e.target.checked == true) {
                            return ({
                                ...value,
                                show: 'yes'
                            })
                        } else {
                            return ({
                                ...value,
                                show: 'no'
                            })
                        }

                    } else {
                        return ({
                            ...value
                        })
                    }
                })
            )
        })
    }
    return (
        <>
            {contextHolder}
            <WYSIWYGModal
                open={open_wyswyg}
                setOpen={set_open_wyswyg}
                data={content?.content}
                setData={setContent}
                handleUpdate={handleUpdate}
            />
            <Modal
                style={{ pointerEvents: 'auto' }}
                open={block_modal}
                bodyStyle={{ backgroundColor: '#faf6f5' }}
                width={450}
                footer={false}
                className="modalStyle2"
                wrapClassName={"modalStyle2"}
                modalRender={(e) => <>
                    <div style={{ backgroundColor: '#faf6f5', padding: '30px', borderTop: `solid #f09a45 5px `, position: 'relative', height: '80vh' }}>
                        <Row gutter={[10, 10]} justify='center' >
                            <Col span={24}>
                                <Row justify="space-between" align={'bottom'}>
                                    <img width="35%" height="35%" src='/cram_school/edit.png' style={{ position: 'relative' }}></img>
                                    <div style={{ fontSize: '1.5em', position: 'absolute', top: '50px', left: '28px' }}>{label_language.home.children.block[language] && '編輯區塊'}</div>
                                </Row>
                            </Col>
                            <Col span={24}>
                                <Row justify={'space-between'}>
                                    <div style={{ fontSize: '1.3em' }}>{label_language.home.children.drag[language] && '請拖拉進行排序'}</div>
                                    <div style={{ fontSize: '1.3em' }}>{label_language.home.children.show_or_not[language] && '是否顯示'}</div>
                                </Row>
                            </Col>
                            <Col span={24} >
                                <DragDropContext onDragEnd={handleDrop}>
                                    <Droppable droppableId="list-container">
                                        {(provided) => (
                                            <div
                                                className="list-container"
                                                {...provided.droppableProps}
                                                ref={provided.innerRef}
                                            >
                                                <Row gutter={[24, 8]} align={'middle'}>
                                                    {itemList.map((item, index) => (
                                                        <>
                                                            <Col span={20}>
                                                                <Draggable key={item.title} draggableId={item.title} index={index}>
                                                                    {(provided) => (
                                                                        <div
                                                                            ref={provided.innerRef}
                                                                            {...provided.dragHandleProps}
                                                                            {...provided.draggableProps}
                                                                        >
                                                                            <div style={{ fontSize: '1.5em', borderStyle: 'outset', borderRadius: '5px', paddingLeft: '10px' }}>{item.title}</div>
                                                                        </div>
                                                                    )}
                                                                </Draggable>
                                                            </Col>
                                                            <Col span={4}>
                                                                <Checkbox
                                                                    checked={item.show == 'yes' ? true : false}
                                                                    onChange={e => handleOnChange(item.title, e)}
                                                                ></Checkbox>
                                                            </Col>
                                                        </>
                                                    ))}
                                                </Row>
                                                {provided.placeholder}
                                            </div>
                                        )}
                                    </Droppable>
                                </DragDropContext>
                            </Col>
                            <Col span={20} style={{ position: 'absolute', bottom: '3vh' }}>
                                <Row gutter={[10, 10]} justify={"center"}>
                                    <Col>
                                        <Button size='large' style={{ background: '#4a4a4a', color: '#ffffff' }} onClick={(e) => { setItemList(defaultList); set_block_modal(false); }} block>{label_language.Common.children.Cancel[language] && '取消'}</Button>
                                    </Col>
                                    <Col >
                                        <Button
                                            onClick={e => updateBlock()}
                                            size='large' style={{ background: '#f09a45', color: '#ffffff' }} block
                                        >{label_language.Common.children.edit[language] && '修改'}</Button>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div>
                </>}
            ></Modal >
            <Row gutter={[8, 16]}>
                {/* <Row gutter={16} align='middle'> */}
                {permission ? <>
                    <Col span={24}>
                        <Button className='example' style={{
                            backgroundColor: '#f09a45', color: '#FFFFFF'
                        }}
                            onClick={e => set_block_modal(true)}> {label_language.home.children.block[language] && '編輯區塊'}</Button>
                    </Col>
                </> : null}
                <Col md={{ span: 24 }} sm={{ span: 24 }} >
                    <LogoList permission={permission} />
                    {/* <map name="workmap">
                        <area shape="rect" coords="872,245,1835,275" alt="logoname" href="airpods.jpg"></area>
                    </map> */}
                    {/* <div style={{ position: 'absolute', top: '0%', fontSize: '4rem' }}>愛麗絲夢遊仙境</div> */}
                </Col>
                {dimensions['width'] > 500 && (<Col md={{ span: 24 }} sm={{ span: 0 }} style={{ background: '#f5f5f5', textAlign: 'center', position: 'relative', overflowY: "scroll", maxHeight: '25vh' }} >
                    <span dangerouslySetInnerHTML={{ __html: content.content }}></span>
                    {permission ? <>
                        <Col style={{ position: 'absolute', left: '90%', top: '0%' }}>
                            <EditOutlined
                                className='example'
                                style={{
                                    backgroundColor: '#F9D4E5',
                                    fontSize: '1.2rem',
                                    borderRadius: '50%',
                                    padding: '8px'
                                }}
                                onClick={e => set_open_wyswyg(true)}
                            />
                        </Col>
                    </> : null}
                </Col>)}
                {itemList && itemList.map((value, i) => {
                    if (value.show == 'yes') {
                        switch (value.title) {
                            case label_language.home.children.lesson_category[language]: {
                                return (
                                    course()
                                )
                            }
                            case label_language.home.children.news[language]: {
                                return (
                                    news()
                                )
                            }
                            case label_language.home.children.tidbits[language]: {
                                return (
                                    tidbits()
                                )
                            }
                            case label_language.home.children.environment[language]: {
                                return (
                                    environment()
                                )
                            }
                            case label_language.home.children.teachers[language]: {
                                return (
                                    teacher()
                                )
                            }
                        }
                    }
                })}
                <Col span={24}>
                    <Row justify={'space-around'} style={{ padding: '20px' }}>
                        <Col className='example' style={{ cursor: 'pointer' }} onClick={e => navigate('/cramSchool/Class')}>
                            <div style={{ position: 'relative' }}>
                                <svg preserveAspectRatio="xMidYMid meet" data-bbox="23.999 20.502 152 158.998" viewBox="23.999 20.502 152 158.998" height="300" width="300" xmlns="http://www.w3.org/2000/svg" data-type="shape" role="presentation" aria-hidden="true" aria-labelledby="svgcid--q6trfg-iphlov"><title id="svgcid--q6trfg-iphlov"></title>
                                    <g >
                                        <path fill='#46A3E3' d="M33.758 60.174c-17.32 24.757-8.751 62.067 3.819 86.859 7.773 15.332 21.838 35.886 46.141 31.984 5.526-.887 10.586-3.167 16.054-4.271 16.952-3.424 36.019 4.667 51.766-1.53 6.229-2.451 11.013-6.889 14.686-11.707 11.588-15.202 12.988-35.352 3.585-51.58-6.596-11.383-18.021-20.815-22.417-32.896-4.313-11.851-1.286-24.74-4.481-36.828-3.886-14.703-20.471-25.243-37.541-16.56-6.449 3.28-11.975 7.686-19.005 10.185-7.319 2.602-15.435 3.282-22.862 5.674-13.94 4.488-23.516 11.767-29.745 20.67z"></path>
                                    </g>
                                </svg>
                            </div>
                            <div style={{ position: 'absolute', top: '35%', left: '20%', fontSize: '40px', color: '#ffffff' }}>
                                {label_language.home.children.tidbits[language] && '上課花絮'}
                            </div>
                            <div style={{ position: 'absolute', top: '55%', left: '35%', fontSize: '69px', fontWeight: 'bold', color: '#FFFFFF' }}>
                                <ArrowRightOutlined />
                            </div>
                        </Col>
                        <Col className='example' style={{ cursor: 'pointer' }} onClick={e => navigate('/cramSchool/Appointment')}>
                            <div style={{ position: 'relative' }}>
                                <svg preserveAspectRatio="none" data-bbox="31.499 20 137.001 160.001" viewBox="31.499 20 137.001 160.001" height="300" width="300" xmlns="http://www.w3.org/2000/svg" data-type="shape" role="presentation" aria-hidden="true" aria-labelledby="svgcid--wz1gan-dt201b"><title id="svgcid--wz1gan-dt201b"></title>
                                    <g>
                                        <path fill='#da9635' d="M166.344 54.704c-1.805-4.794-4.774-9.353-9.025-13.403-11.189-10.658-30.812-17.352-48.765-20.236-47.41-7.615-75.151 27.098-76.986 56.126-.874 13.824 6.889 27.31 7.497 41.175.652 14.878-5.574 29.557-2.586 44.536 1.666 8.348 8.576 13.214 20.06 15.16 34.353 5.821 80.34-1.147 97.585-25.256 4.83-6.752 6.951-14.461 7.698-21.959.881-8.85-1.181-17.654-1.463-26.49-.268-8.412 2.606-16.449 5.664-24.509 3.091-8.151 3.392-16.986.321-25.144z"></path>
                                    </g>
                                </svg>
                                <div style={{ position: 'absolute', top: '35%', left: '20%', fontSize: '40px', color: '#FFFFFF' }}>
                                    {label_language.home.children.appointment[language] && '填單預約'}
                                </div>
                                <div style={{ position: 'absolute', top: '55%', left: '35%', fontSize: '69px', fontWeight: 'bold', color: '#ffffff' }}>
                                    <ArrowRightOutlined />
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Col>
                {/* <Col span={24}>
                    <Col span={24}>
                        <Row justify={'center'} align="middle" style={{ padding: '10px', position: 'relative' }}>
                            <Col>
                                <Col style={{ textAlign: 'center' }}>
                                    <span style={{ fontSize: dimensions['width'] > 500 ? '3.5rem' : '3rem' }}>我們的教室</span>
                                </Col>
                            </Col >
                        </Row>
                    </Col>
                </Col> */}

            </Row >

        </>
    )
}
export default Home;
